export default "__VITE_ASSET__CSGI5qNC__"